import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const TAWK_PROPERTY_ID = import.meta.env.VITE_TAWK_PROPERTY_ID;
const TAWK_WIDGET_ID = import.meta.env.VITE_TAWK_WIDGET_ID;

// Routes where Tawk.to should be shown (authenticated app routes)
const AUTHENTICATED_ROUTES = ['/app', '/dashboard', '/admin'];

export const TawkToWidget = () => {
  const location = useLocation();

  useEffect(() => {
    if (!TAWK_PROPERTY_ID || !TAWK_WIDGET_ID) {
      console.warn('Tawk.to not configured');
      return;
    }

    let isAuthenticated = false;
    let scriptLoaded = false;

    // Check if user is authenticated and on an authenticated route
    const checkAuthAndRoute = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      isAuthenticated = !!session;
      
      const isAuthenticatedRoute = AUTHENTICATED_ROUTES.some(route => 
        location.pathname.startsWith(route)
      );

      // Only load Tawk.to if authenticated AND on authenticated route
      if (isAuthenticated && isAuthenticatedRoute && !scriptLoaded) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`;
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');
        document.body.appendChild(script);
        scriptLoaded = true;
      } else if ((!isAuthenticated || !isAuthenticatedRoute) && scriptLoaded) {
        // Hide widget if not authenticated or on public route
        const tawkWidget = document.getElementById('tawkchat-container');
        if (tawkWidget) {
          tawkWidget.style.display = 'none';
        }
      } else if (isAuthenticated && isAuthenticatedRoute && scriptLoaded) {
        // Show widget again if navigating back to authenticated route
        const tawkWidget = document.getElementById('tawkchat-container');
        if (tawkWidget) {
          tawkWidget.style.display = 'block';
        }
      }
    };

    checkAuthAndRoute();

    return () => {
      // Only hide widget on unmount, don't remove script
      const tawkWidget = document.getElementById('tawkchat-container');
      if (tawkWidget) {
        tawkWidget.style.display = 'none';
      }
    };
  }, [location.pathname]);

  return null; // This component doesn't render anything
};
